import axiosWithAuth from "../utils/axiosWithAuth";
import { backUrl } from "../utils/backURL";
const API_URL = backUrl;

export const getFlows = async (mantisBusinessId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('flowsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${mantisBusinessId}`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('flowsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('flowsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener los flujos:", error.response?.data || error);
    throw error;
  }
};
export const getWorkflowResultsByIdP2O = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('resultsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/orderbyid/${orderId}`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('resultsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('resultsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener los resultados de la orden:", error.response?.data || error);
    throw error;
  }
};
export const getWorkflowResultsp2p = async (clientId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('resultsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/iprs`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('resultsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('resultsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener los resultados del workflow:", error.response?.data || error);
    throw error;
  }
};
export const getWorkflowResults = async (clientId, workflowId, mantisBusinessUserId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('resultsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/${clientId}/results/${workflowId}?userId=${mantisBusinessUserId}`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('resultsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('resultsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener los resultados del workflow:", error.response?.data || error);
    throw error;
  }
};
export const getWorkflowFilterOptions = async (clientId, workflowId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/${clientId}/filters/${workflowId}`);
    return response.data;
  } catch (error) {
    console.error('API Call: Error en getWorkflowFilterOptions:', error);
    throw error;
  }
};
export const getWorkflowFilterOptionsp2p = async (clientId, workflowId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/filters/${workflowId}`);
    return response.data;
  } catch (error) {
    console.error('API Call: Error en getWorkflowFilterOptions:', error);
    throw error;
  }
};
export const getWorkflowStatistics = async (clientId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('statsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/${clientId}/statistics`);
        
    // Enviar evento para ocultar esqueleto 
    const endEvent = new CustomEvent('statsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    // Verificar que response.data sea un array
    if (Array.isArray(response.data)) {
      return {
        success: true,
        data: response.data
      };
    } else {
      // Si no es un array, pero tiene datos, los envolvemos en un array
      return {
        success: true,
        data: [response.data]
      };
    }
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('statsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener las estadísticas del workflow:", error);
    return {
      success: false,
      error: error.message || "Error al obtener las estadísticas del workflow"
    };
  }
};
export const getWorkflowStatisticsp2p = async (clientId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('statsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/statistics`);
        
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('statsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    // Verificar que response.data sea un array
    if (Array.isArray(response.data)) {
      return {
        success: true,
        data: response.data
      };
    } else {
      // Si no es un array, pero tiene datos, los envolvemos en un array
      return {
        success: true,
        data: [response.data]
      };
    }
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('statsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener las estadísticas del workflow:", error);
    return {
      success: false,
      error: error.message || "Error al obtener las estadísticas del workflow"
    };
  }
};
export const subscribeToFlowStatusUpdates = (flowId, onStatusUpdate) => {
  // Validate flowId
  if (!flowId) {
    console.error("[SSE] Subscription failed: flowId is required.");
    return null; // Return null or throw an error if flowId is missing
  }
  
  console.log(`[SSE] Subscribing to status updates for flow: ${flowId}`);
  
  // Use the correct endpoint from FlowManagments.js
  const eventSourceUrl = `${API_URL}/workflows/events/${flowId}`; 
  console.log(`[SSE] Creating EventSource with URL: ${eventSourceUrl}`);
  
  let eventSource;
  try {
    eventSource = new EventSource(eventSourceUrl);
  } catch (error) {
    console.error(`[SSE] Failed to create EventSource for ${flowId}:`, error);
    return null; // Return null if EventSource creation fails
  }
  
  // Handle incoming messages
  eventSource.onmessage = (event) => {    
    try {
      const data = JSON.parse(event.data);
      console.log(`[SSE] Parsed event for flow ${flowId}:`, event.status);
      
      // Pass the parsed data to the callback
      onStatusUpdate(data); 
      
    } catch (error) {
      console.error(`[SSE] Error processing SSE event for flow ${flowId}:`, error);
      console.log("[SSE] Raw event data that caused error:", event.data);
    }
  };
  
  // Handle connection errors
  eventSource.onerror = (error) => {
    console.error(`[SSE] Connection error for flow ${flowId}:`, error);
    // The browser will automatically attempt to reconnect for EventSource errors.
    // You might want to implement custom logic here if needed, e.g., exponential backoff
    // or closing after too many failed attempts.
    // For now, we log the error. EventSource handles reconnection attempts by default.
    // Closing the connection might prevent automatic retries.
    // eventSource.close(); // Consider if you want to stop retries on error
  };
  
  // Handle connection open
  eventSource.onopen = () => {
    console.log(`[SSE] Connection opened successfully for flow: ${flowId}`);
  };
  
  return eventSource; // Return the EventSource so it can be closed if needed
};
export const unsubscribeFromFlowStatusUpdates = (eventSource) => {
  if (eventSource) {
    const url = eventSource.url; // Get URL for logging before closing
    console.log(`[SSE] Closing SSE connection to ${url}`);
    eventSource.close();
  }
};

export const updateExtractedField = async (clientId, workflowId, field, value, rowId, runId) => {
  try {
    const response = await axiosWithAuth.patch(`${API_URL}/workflows/p2p/${clientId}/${workflowId}`, {
      field: field,
      value: value,
      rowId: rowId,
      runId: runId
    });
    return response.data;
  } catch (error) {
    console.error("Error al actualizar el campo:", error.response?.data || error);
    throw error;
  }
};

export const getOrderItems = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('itemsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/items`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('itemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    console.log("response_data", response.data);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('itemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener los items de la orden:", error.response?.data || error);
    throw error;
  }
};

export const getIPRProducts = async (clientId, iprId) => {
  try {
    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/requests/${iprId}/products`);
    return response.data;
  } catch (error) {
    console.error("Error fetching all quoted items:", error);
    throw error;
  }
};

export const updateIPRItem = async (
  clientId,
  orderId,
  itemId,
  fieldName,
  fieldValue
) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent("itemUpdating", {detail: true});
    window.dispatchEvent(event);
    const response = await axiosWithAuth.patch(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/items/${itemId}`,
      {fieldName, fieldValue}
    );
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent("itemUpdating", {detail: false});
    window.dispatchEvent(endEvent);
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent("itemUpdating", {detail: false});
    window.dispatchEvent(endEvent);
    console.error(
      "Error al actualizar el item de la orden:",
      error.response?.data || error
    );
    throw error;
  }
};

// Funciones para gestionar proveedores (suppliers)

// Funciones para gestionar cotizaciones (quotations)

/**
 * Crea cotizaciones para múltiples proveedores con una orden específica
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {Array<string>} supplierIds - Array con IDs de proveedores
 * @returns {Promise<Object>} - Respuesta con las cotizaciones creadas
 */
export const createQuotationsForSuppliers = async (clientId, orderId, supplierIds, suppliers, items = [], fileData = null) => {
  try {
    // Enviar evento para mostrar esqueleto o indicador de carga
    const event = new CustomEvent('quotationsCreating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/quotations`, 
      { supplierIds, suppliers, items, fileData }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationsCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationsCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al crear cotizaciones:", error.response?.data || error);
    throw error;
  }
};


/**
 * Actualiza el estado de una cotización
 * @param {string} clientId - ID del cliente
 * @param {string} quotationId - ID de la cotización
 * @param {string} status - Nuevo estado de la cotización
 * @returns {Promise<Object>} - Respuesta con la cotización actualizada
 */
export const updateQuotationStatus = async (clientId, quotationId, status) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('quotationStatusUpdating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.patch(
      `${API_URL}/workflows/p2p/${clientId}/quotations/${quotationId}/status`, 
      { status }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationStatusUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationStatusUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al actualizar estado de cotización:", error.response?.data || error);
    throw error;
  }
};

/**
 * Marca una cotización como enviada
 * @param {string} clientId - ID del cliente
 * @param {string} quotationId - ID de la cotización
 * @returns {Promise<Object>} - Respuesta con la cotización actualizada
 */
export const markQuotationAsSent = async (clientId, quotationId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('quotationSending', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/quotations/${quotationId}/send`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al marcar cotización como enviada:", error.response?.data || error);
    throw error;
  }
};

/**
 * Marca una cotización como respondida
 * @param {string} clientId - ID del cliente
 * @param {string} quotationId - ID de la cotización
 * @param {Array} items - Items de la cotización con precios
 * @param {number} itemsCount - Cantidad de items respondidos
 * @returns {Promise<Object>} - Respuesta con la cotización actualizada
 */
export const markQuotationAsResponded = async (clientId, quotationId, items, itemsCount) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('quotationResponding', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/quotations/${quotationId}/respond`,
      { items, itemsCount }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationResponding', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationResponding', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al marcar cotización como respondida:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene los items cotizados por proveedores para una orden específica
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @returns {Promise<Object>} - Respuesta con los items cotizados
 */
export const getQuotationItemsByOrderId = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('quotationItemsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/quotation-items`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationItemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationItemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener items cotizados para la orden:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene los items de una cotización específica
 * @param {string} clientId - ID del cliente
 * @param {string} quotationId - ID de la cotización
 * @returns {Promise<Object>} - Respuesta con los items de la cotización
 */
export const getQuotationItemsByQuotationId = async (clientId, quotationId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('quotationItemsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/quotations/${quotationId}/items`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationItemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationItemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener items de la cotización:", error.response?.data || error);
    throw error;
  }
};

/**
 * Agrega un nuevo item a una cotización
 * @param {string} clientId - ID del cliente
 * @param {string} quotationId - ID de la cotización
 * @param {Object} itemData - Datos del item a agregar (orderItemId, unitPrice, deliveryTimeDays, currency, comments)
 * @returns {Promise<Object>} - Respuesta con el item agregado
 */
export const addItemToQuotation = async (clientId, quotationId, itemData) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('quotationItemAdding', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/quotations/${quotationId}/items`, 
      itemData
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('quotationItemAdding', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('quotationItemAdding', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al agregar item a la cotización:", error.response?.data || error);
    throw error;
  }
};

/**
 * Crea una nueva orden de compra basada en una cotización seleccionada
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden original
 * @param {Object} poData - Datos para crear la orden de compra (supplierId, quotationId, items, deliveryAddress, etc)
 * @returns {Promise<Object>} - Respuesta con la orden de compra creada
 */
export const createPurchaseOrder = async (clientId, orderId, poData, supplierId, items, userId="") => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('purchaseOrderCreating', { detail: true });
    window.dispatchEvent(event);

    // Extract form fields from poData and create the request body
    const {
      currency,
      expectedDeliveryDate,
      payment_terms,
      shipping_terms,
      notes,
      address,
      city,
      zip_code,
      shipping_address,
      tax_rate,
      shipping_cost,
      other_costs,
      discount_percentage
    } = poData;

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/purchase-orders`, 
      { 
        supplierId, 
        poData: {
          currency,
          expectedDeliveryDate,
          payment_terms,
          shipping_terms,
          notes
        }, 
        items, 
        userId,
        address,
        city,
        zip_code,
        shipping_address,
        tax_rate,
        shipping_cost,
        other_costs,
        discount_percentage
      }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('purchaseOrderCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('purchaseOrderCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al crear la orden de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene todas las órdenes de compra para un cliente
 * @param {string} clientId - ID del cliente
 * @param {Object} filters - Filtros opcionales (status, dateRange, supplierId, etc)
 * @returns {Promise<Object>} - Respuesta con las órdenes de compra
 */
export const getPurchaseOrders = async (clientId, filters = {}) => {
  try {
    // Construir query params para los filtros
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });
    
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poLoading', { detail: true });
    window.dispatchEvent(event);

    const url = `${API_URL}/workflows/p2p/${clientId}/purchase-orders${
      queryParams.toString() ? `?${queryParams.toString()}` : ''
    }`;
    
    const response = await axiosWithAuth.get(url);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener órdenes de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene todas las órdenes de compra para un IPR
 * @param {string} clientId - ID del cliente
 * @param {string} iprId - ID del IPR
 * @param {Object} filters - Filtros opcionales (status, dateRange, supplierId, etc)
 * @returns {Promise<Object>} - Respuesta con las órdenes de compra
 */
export const getPurchaseOrdersByIPRId = async (clientId, filters = {}, iprId) => {
  try {
    // Construir query params para los filtros
    const queryParams = new URLSearchParams();
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryParams.append(key, value);
      }
    });

    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poLoading', { detail: true });
    window.dispatchEvent(event);

    const url = `${API_URL}/workflows/p2p/${clientId}/purchase-orders-ipr/${iprId}${queryParams.toString() ? `?${queryParams.toString()}` : ''
      }`;

    const response = await axiosWithAuth.get(url);

    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poLoading', { detail: false });
    window.dispatchEvent(endEvent);

    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poLoading', { detail: false });
    window.dispatchEvent(endEvent);

    console.error("Error al obtener órdenes de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene una orden de compra específica por su ID
 * @param {string} clientId - ID del cliente
 * @param {string} purchaseOrderId - ID de la orden de compra
 * @returns {Promise<Object>} - Respuesta con la orden de compra
 */
export const getPurchaseOrderById = async (clientId, purchaseOrderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poDetailLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(
      `${API_URL}/workflows/p2p/${clientId}/purchase-orders/${purchaseOrderId}`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poDetailLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poDetailLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener detalles de la orden de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Actualiza el estado de una orden de compra
 * @param {string} clientId - ID del cliente
 * @param {string} purchaseOrderId - ID de la orden de compra
 * @param {string} status - Nuevo estado ('pending', 'sent', 'confirmed', 'received', 'cancelled')
 * @param {string} statusDate - Fecha del cambio de estado (opcional)
 * @returns {Promise<Object>} - Respuesta con la orden de compra actualizada
 */
export const updatePurchaseOrderStatus = async (clientId, purchaseOrderId, status, statusDate = null) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poStatusUpdating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.patch(
      `${API_URL}/workflows/p2p/${clientId}/purchase-orders/${purchaseOrderId}/status`,
      { status, statusDate }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poStatusUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poStatusUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al actualizar estado de la orden de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene los items de una orden de compra específica
 * @param {string} clientId - ID del cliente
 * @param {string} purchaseOrderId - ID de la orden de compra
 * @returns {Promise<Object>} - Respuesta con los items de la orden de compra
 */
export const getPurchaseOrderItems = async (clientId, purchaseOrderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poItemsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(
      `${API_URL}/workflows/p2p/${clientId}/purchase-orders/${purchaseOrderId}/items`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poItemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poItemsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener items de la orden de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Genera un documento PDF para una orden de compra
 * @param {string} clientId - ID del cliente
 * @param {string} purchaseOrderId - ID de la orden de compra
 * @returns {Promise<Object>} - Respuesta con la URL del documento generado
 */
export const generatePurchaseOrderDocument = async (clientId, purchaseOrderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poDocGenerating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/purchase-orders/${purchaseOrderId}/generate-document`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poDocGenerating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poDocGenerating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al generar documento de orden de compra:", error.response?.data || error);
    throw error;
  }
};

/**
 * Envía una orden de compra al proveedor por email
 * @param {string} clientId - ID del cliente
 * @param {string} purchaseOrderId - ID de la orden de compra
 * @param {Object} emailData - Datos para el email (recipients, subject, message, etc)
 * @returns {Promise<Object>} - Respuesta con el resultado del envío
 */
export const sendPurchaseOrderToSupplier = async (clientId, purchaseOrderId, emailData) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poSending', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/purchase-orders/${purchaseOrderId}/send`,
      emailData
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al enviar orden de compra al proveedor:", error.response?.data || error);
    throw error;
  }
};

/**
 * Registra la recepción de items de una orden de compra
 * @param {string} clientId - ID del cliente
 * @param {string} purchaseOrderId - ID de la orden de compra
 * @param {Object} receiptData - Datos de la recepción (items recibidos, fecha, notas, etc)
 * @returns {Promise<Object>} - Respuesta con el resultado del registro
 */
export const registerPurchaseOrderReceipt = async (clientId, purchaseOrderId, receiptData) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('poReceiptRegistering', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/purchase-orders/${purchaseOrderId}/receipt`,
      receiptData
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('poReceiptRegistering', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('poReceiptRegistering', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al registrar recepción de orden de compra:", error.response?.data || error);
    throw error;
  }
};
// Funciones para gestionar comentarios

/**
 * Crea un nuevo comentario
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {string} comment - Texto del comentario
 * @param {string} user_name - Nombre del usuario que crea el comentario
 * @returns {Promise<Object>} - Respuesta con el comentario creado
 */
export const createComment = async (clientId, orderId, comment, user_name) => {
  try {
    // Enviar evento para mostrar esqueleto o indicador de carga
    const event = new CustomEvent('commentCreating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/comments`,
      { comment, user_name }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('commentCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('commentCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al crear el comentario:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene los comentarios de una orden específica
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @returns {Promise<Object>} - Respuesta con los comentarios
 */
export const getCommentsByOrderId = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('commentsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/comments`);
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('commentsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('commentsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener los comentarios:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene los archivos de un IPR específico
 * @param {string} clientId - ID del cliente
 * @param {string} iprId - ID del IPR
 * @returns {Promise<Object>} - Respuesta con los archivos
 */
export const getFilesByIPRId = async (clientId, iprId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('filesLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(`${API_URL}/workflows/p2p/${clientId}/iprs/${iprId}/files`);

    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('filesLoading', { detail: false });
    window.dispatchEvent(endEvent);

    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('filesLoading', { detail: false });
    window.dispatchEvent(endEvent);

    console.error("Error al obtener los archivos:", error.response?.data || error);
    throw error;
  }
};


/**
 * Actualiza un comentario existente
 * @param {string} clientId - ID del cliente
 * @param {string} commentId - ID del comentario
 * @param {string} comment - Nuevo texto del comentario
 * @param {string} user_name - Nombre del usuario que actualiza el comentario
 * @param {string} orderId - ID de la orden asociada al comentario
 * @returns {Promise<Object>} - Respuesta con el comentario actualizado
 */
export const updateComment = async (clientId, commentId, comment, user_name, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('commentUpdating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.patch(
      `${API_URL}/workflows/p2p/${clientId}/comments/${commentId}`, 
      { comment, user_name, orderId }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('commentUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('commentUpdating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al actualizar el comentario:", error.response?.data || error);
    throw error;
  }
};

/**
 * Elimina un comentario existente
 * @param {string} clientId - ID del cliente
 * @param {string} commentId - ID del comentario
 * @param {string} user_name - Nombre del usuario que elimina el comentario
 * @param {string} orderId - ID de la orden asociada al comentario
 * @returns {Promise<Object>} - Respuesta con el comentario eliminado
 */
export const deleteComment = async (clientId, commentId, user_name, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('commentDeleting', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.delete(
      `${API_URL}/workflows/p2p/${clientId}/comments/${commentId}`,
      { data: { user_name, orderId } }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('commentDeleting', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('commentDeleting', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al eliminar el comentario:", error.response?.data || error);
    throw error;
  }
};

/**
 * Envía correos electrónicos a proveedores para solicitar cotizaciones
 * @param {string} clientId - ID del cliente
 * @param {string} workflowId - ID del workflow
 * @param {string} orderId - ID de la orden
 * @param {Array} suppliers - Array de objetos proveedor con al menos {id, name, email}
 * @param {Object} options - Opciones adicionales (subject, message, attachments, userName)
 * @returns {Promise<Object>} - Respuesta con el resultado del envío
 */
export const sendEmailToSuppliers = async (clientId, orderId, suppliers, options = {}) => {
  try {
    // Enviar evento para mostrar esqueleto o indicador de carga
    const event = new CustomEvent('emailSending', { detail: true });
    window.dispatchEvent(event);

    // Preparar el cuerpo de la solicitud con solo los datos necesarios
    const requestBody = {
      suppliers
    };

    // Añadir opciones adicionales solo si se proporcionan
    if (options.subject) requestBody.subject = options.subject;
    if (options.message) requestBody.message = options.message;
    if (options.attachments) requestBody.attachments = options.attachments;
    if (options.userName) requestBody.user_name = options.userName;

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/email-supplier`, 
      requestBody
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('emailSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('emailSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al enviar correos a proveedores:", error.response?.data || error);
    throw error;
  }
};

/**
 * Envía mensajes de WhatsApp a proveedores para solicitar cotizaciones (RFQ)
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {Array} suppliers - Array de objetos proveedor con al menos {id, name, phone, whatsapp}
 * @param {Object} options - Opciones adicionales (message, attachments, userName)
 * @returns {Promise<Object >} - Respuesta con el resultado del envío
 */
export const sendRFQToSupplier = async (clientId, orderId, suppliers, options = {}) => {
  try {
    // Enviar evento para mostrar esqueleto o indicador de carga
    const event = new CustomEvent('whatsappSending', { detail: true });
    window.dispatchEvent(event);

    // Preparar el cuerpo de la solicitud
    const requestBody = {
      suppliers: suppliers.map(supplier => ({
        id: supplier.id,
        name: supplier.name,
        phone: supplier.phone,
        whatsapp: supplier.whatsapp,
        email: supplier.email,
        // Si el supplier tiene items específicos, los incluimos
        ...(supplier.items && { items: supplier.items })
      })),
      attachments: options.attachments || [],
      clientName: options.clientName,
      subject: options.subject,
      message: options.message
    };

    // Si hay items globales para todos los suppliers, los agregamos al nivel superior
    if (options.items) {
      requestBody.items = options.items;
    }

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/rfq-supplier`, 
      requestBody
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('whatsappSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('whatsappSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al enviar WhatsApp RFQ a proveedores:", error.response?.data || error);
    throw error;
  }
};

/**
 * Asigna items específicos a diferentes suppliers
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {Array} assignments - Array de objetos {itemId, supplierId}
 * @param {string} userId - ID del usuario que realiza la asignación
 * @returns {Promise<Object>} - Respuesta con las asignaciones creadas
 */
export const assignItemsToSuppliers = async (clientId, orderId, assignments, userId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('itemsAssigning', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/assign-suppliers`,
      { assignments, userId }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('itemsAssigning', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('itemsAssigning', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al asignar items a suppliers:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene los items con sus suppliers asignados para una orden específica
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @returns {Promise<Object>} - Respuesta con items y suppliers asignados
 */
export const getItemsWithAssignedSuppliers = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('itemsSuppliersLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/items-suppliers`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('itemsSuppliersLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('itemsSuppliersLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener items con suppliers asignados:", error.response?.data || error);
    throw error;
  }
};

/**
 * Crea automáticamente Purchase Orders separadas para cada supplier basado en las asignaciones de items
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {Object} options - Opciones adicionales (deliveryAddress, notes, etc)
 * @returns {Promise<Object>} - Respuesta con las Purchase Orders creadas
 */
export const createPurchaseOrdersBySupplier = async (clientId, orderId, options = {}) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('posBySupplierCreating', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/create-pos-by-supplier`,
      options
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('posBySupplierCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('posBySupplierCreating', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al crear Purchase Orders por supplier:", error.response?.data || error);
    throw error;
  }
};

/**
 * Envía correos personalizados a cada supplier con solo los items que les fueron asignados
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {Object} emailOptions - Opciones del email (subject, message, userName)
 * @returns {Promise<Object>} - Respuesta con el resultado del envío
 */
export const sendEmailToAssignedSuppliers = async (clientId, orderId, emailOptions = {}) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('assignedEmailSending', { detail: true });
    window.dispatchEvent(event);

    const requestBody = {
      subject: emailOptions.subject || 'Request for Quotation - Assigned Items',
      message: emailOptions.message || 'Please provide a quotation for the assigned items.',
      user_name: emailOptions.userName || 'System'
    };

    const response = await axiosWithAuth.post(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/email-suppliers-assigned`,
      requestBody
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('assignedEmailSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('assignedEmailSending', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al enviar correos a suppliers asignados:", error.response?.data || error);
    throw error;
  }
};

/**
 * Remueve la asignación de un item a un supplier
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @param {string} itemId - ID del item
 * @param {string} userId - ID del usuario que remueve la asignación
 * @returns {Promise<Object>} - Respuesta con el resultado
 */
export const removeItemSupplierAssignment = async (clientId, orderId, itemId, userId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('itemAssignmentRemoving', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.delete(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/items/${itemId}/supplier-assignment`,
      { data: { userId } }
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('itemAssignmentRemoving', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('itemAssignmentRemoving', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al remover asignación de item:", error.response?.data || error);
    throw error;
  }
};

/**
 * Obtiene estadísticas de asignaciones de suppliers para una orden
 * @param {string} clientId - ID del cliente
 * @param {string} orderId - ID de la orden
 * @returns {Promise<Object>} - Respuesta con estadísticas de asignaciones
 */
export const getSupplierAssignmentStats = async (clientId, orderId) => {
  try {
    // Enviar evento para mostrar esqueleto
    const event = new CustomEvent('assignmentStatsLoading', { detail: true });
    window.dispatchEvent(event);

    const response = await axiosWithAuth.get(
      `${API_URL}/workflows/p2p/${clientId}/iprs/${orderId}/supplier-assignment-stats`
    );
    
    // Enviar evento para ocultar esqueleto
    const endEvent = new CustomEvent('assignmentStatsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    return response.data;
  } catch (error) {
    // Enviar evento para ocultar esqueleto en caso de error
    const endEvent = new CustomEvent('assignmentStatsLoading', { detail: false });
    window.dispatchEvent(endEvent);
    
    console.error("Error al obtener estadísticas de asignaciones:", error.response?.data || error);
    throw error;
  }
};

export const updateItemsInStock = async (clientId, items) => {
  try {
    const response = await axiosWithAuth.put(
      `${API_URL}/workflows/p2p/${clientId}/items/stock`,
      { items }
    );
    return response.data;
  } catch (error) {
    console.error('Error en updateItemsInStock:', error);
    throw error;
  }
};

export const updateInitialPurchaseRequestField = async (clientId, iprId, fieldName, fieldValue) => {
  try {
    const response = await axiosWithAuth.patch(
      `${API_URL}/workflows/p2p/${clientId}/initial-purchase-requests/${iprId}/field`,
      { fieldName, fieldValue }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating initial purchase request field:", error.response?.data || error);
    throw error;
  }
};